import { BILLING_CYCLES } from 'settings/constants/billing'
import {
  TWO_MONTH_SCHEDULE_OPTIONS,
  FOUR_MONTH_SCHEDULE_OPTIONS,
  SIX_MONTH_SCHEDULE_OPTIONS,
  ANNUAL_SCHEDULE_OPTIONS,
  QUARTERLY_SCHEDULE_OPTIONS,
  TWO_QUARTER_SCHEDULE_OPTIONS,
} from 'settings/constants/day'

const { MONTH, QUARTER, YEAR } = BILLING_CYCLES

// Cycle length in months -> anchor options, matching BillingMonths.cycleLengthMonths on the
// backend. Cadences absent here have no First-months concept.
const FIRST_MONTHS_OPTIONS_BY_CYCLE_LENGTH = {
  2: TWO_MONTH_SCHEDULE_OPTIONS,
  4: FOUR_MONTH_SCHEDULE_OPTIONS,
  6: SIX_MONTH_SCHEDULE_OPTIONS,
  12: ANNUAL_SCHEDULE_OPTIONS,
}

const getMonthCycleLength = cycle => {
  if (cycle?.intervalType === MONTH) return cycle?.interval
  if (cycle?.intervalType === YEAR) return 12 * (cycle?.interval ?? 1)
  // Quarter cycles anchor via timingQuarter; Week/Day/Manual have no month anchor
  return undefined
}

export const isBiMonthlyBillingCycle = cycle => cycle?.intervalType === MONTH && cycle?.interval === 2

export const isFourMonthBillingCycle = cycle => cycle?.intervalType === MONTH && cycle?.interval === 4

export const isSixMonthBillingCycle = cycle => cycle?.intervalType === MONTH && cycle?.interval === 6

export const isQuarterlyBillingCycle = cycle => cycle?.intervalType === QUARTER && cycle?.interval === 1

export const isTwoQuarterBillingCycle = cycle => cycle?.intervalType === QUARTER && cycle?.interval === 2

export const getFirstMonthsScheduleOptions = cycle => FIRST_MONTHS_OPTIONS_BY_CYCLE_LENGTH[getMonthCycleLength(cycle)] ?? []

export const hasFirstMonths = cycle => getFirstMonthsScheduleOptions(cycle).length > 0

export const getQuarterlyScheduleOptions = cycle => {
  if (isQuarterlyBillingCycle(cycle)) {
    return QUARTERLY_SCHEDULE_OPTIONS
  }

  if (isTwoQuarterBillingCycle(cycle)) {
    return TWO_QUARTER_SCHEDULE_OPTIONS
  }

  return []
}
